import ApiService from "@/common/api/api.service";

let endpoint = "Projeto";

const CronogramaEtapa = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    salvarEtapa(form) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${endpoint}/realizar-etapa`, form.etapa).then(() => {
                if(form.etapa.prevista){
                    resolve();
                }

                ApiService.put(`${endpoint}/etapa`, form.etapa).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })    
            }).catch(() => {
                reject();
            })
        });
    },


    salvarSubetapa(form) {
        return new Promise((resolve, reject) => {
            if(form.cronogramaEtapaId){
                form.mesInicial = form.mesInicialRealizado;
                form.mesFinal = form.mesFinalRealizado;

                ApiService.post(`${endpoint}/subetapa`, form).then(res => {
                    resolve(res.data.data);
                }).catch(() => {
                    reject();
                })  
                return;
            }

            ApiService.put(`${endpoint}/realizar-subetapa`, form).then(() => {
                if(form.prevista){
                    resolve();
                }

                ApiService.put(`${endpoint}/subetapa`, form).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })    
            }).catch(() => {
                reject();
            })
        });
    },
    
    salvarRelatorio(form) {
        return new Promise((resolve, reject) => {
            if(form.cronogramaEtapaId){
                form.mesFinal = form.mesFinalRealizado;
                ApiService.post(`${endpoint}/relatorio-etapa`, form).then(res => {
                    resolve(res.data.data);
                }).catch(() => {
                    reject();
                })  
                return;
            }

            ApiService.put(`${endpoint}/realizar-relatorio-etapa`, form).then(() => {
                if(form.previsto){
                    resolve();
                }

                ApiService.put(`${endpoint}/relatorio-etapa`, form).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })    
            }).catch(() => {
                reject();
            })
        });
    },

    removerRelatorio(id) {
        return ApiService.delete(`${endpoint}/relatorio-etapa?id=${id}`);
    },

    removerSubetapa(id) {
        return ApiService.delete(`${endpoint}/subetapa?id=${id}`);
    },

    salvarDetalhamento(form) {
        return ApiService.put(`${endpoint}/cronograma-etapa`, form);
    },

    excluirCronograma(id) {
        return ApiService.delete(`${endpoint}/cronograma-etapa?id=${id}`);
    },

    listarCronograma(id) {
        return ApiService.get(`ProjetoEmpresaExecutoraCriadora/cronograma-etapa?projetoId=${id}`);
    },
    
    uploadRelatorio(form){
        return ApiService.put(`${endpoint}/adicionar-arquivo-relatorio`, form);
    },

    downloadRelatorio(id){
        return ApiService.downloadFile(`${endpoint}/download-arquivo-relatorio?id=${id}`);
    },
    
    aprovarRelatorio(id){
        return ApiService.put(`${endpoint}/aprovar-relatorio-etapa?id=${id}`);
    },

    excluirArquivo(id){
        return ApiService.delete(`${endpoint}/excluir-arquivo-relatorio?id=${id}`);
    },

    buscarCronogramaPeloRelatorio(id) {
        return ApiService.get(`ProjetoEmpresaExecutoraCriadora/relatorio-etapa?id=${id}`);
    },
}

export default CronogramaEtapa;
